// ISO 3166-1 alpha-2 country codes supported by the phone country picker.
// Hand-maintained: country is not a submitted request field today, so there is
// no generated OpenAPI schema to derive this from (contrast
// `preferred-contact-method.ts`, which mirrors a generated backend enum).

export const CountryCode = {
  US: 'US'
} as const satisfies Record<string, string>

export type CountryCode = (typeof CountryCode)[keyof typeof CountryCode]
